<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.HONOUR_ROLL_TOOLS.TITLE' | translate }}</h4>
  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tableAccentColorControl"
    labelTranslateKey="PRESENTER.HONOUR_ROLL_TOOLS.CARD_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tablePrimaryColorControl"
    labelTranslateKey="PRESENTER.HONOUR_ROLL_TOOLS.PRIMARY_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tableBackgroundColorControl"
    labelTranslateKey="PRESENTER.HONOUR_ROLL_TOOLS.BACKGROUND_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <div class="icon-button-group-field">
    <h4 class="tools-title">{{ 'PRESENTER.HONOUR_ROLL_TOOLS.LAYOUT_DIRECTION' | translate }}</h4>

    <div class="icon-button-group">
      <button
        type="button"
        class="icon-button"
        [class.icon-button--active]="layoutDirectionControl.value === 'horizontal'"
        (click)="layoutDirectionControl.setValue('horizontal'); setDefaults(HonorRollLayoutDirectionEnum.HORIZONTAL)"
      >
        <mat-icon>view_stream</mat-icon>
      </button>

      <button
        type="button"
        class="icon-button"
        [class.icon-button--active]="layoutDirectionControl.value === 'vertical'"
        (click)="layoutDirectionControl.setValue('vertical'); setDefaults(HonorRollLayoutDirectionEnum.VERTICAL)"
      >
        <mat-icon>view_column</mat-icon>
      </button>
    </div>
  </div>

  <gb-presenter-tools-advanced-options-container>
    <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>

    <mat-form-field>
      <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.SIZE' | translate }}</mat-label>
      <input matInput type="number" [formControl]="fontSizeControl" min="1" max="20" />
      @if (fontSizeControl.hasError('max')) {
        <mat-error>
          {{ 'PRESENTER.HONOUR_ROLL_TOOLS.FONT_SIZE_MAX_ERROR' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-slide-toggle [formControl]="showItemAliasControl">
      {{ 'PRESENTER.HONOUR_ROLL_TOOLS.SHOW_ITEM_CODE' | translate }}
    </mat-slide-toggle>

    <mat-slide-toggle [formControl]="showItemNameControl">
      {{ 'PRESENTER.HONOUR_ROLL_TOOLS.SHOW_ITEM_NAME' | translate }}
    </mat-slide-toggle>

    <mat-form-field>
      <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.LATEST_ACTIVITY_QUANTITY' | translate }}</mat-label>
      <input matInput type="number" [formControl]="latestActivitiesControl" min="1" max="100" />
    </mat-form-field>

    <div class="icon-button-group-field">
      <h4 class="tools-title">{{ 'PRESENTER.HONOUR_ROLL_TOOLS.PARTICIPANTS_TRANSITION' | translate }}</h4>

      <div class="icon-button-group">
        <button
          type="button"
          class="icon-button"
          [class.icon-button--active]="transitionControl.value === 'scroll-left'"
          (click)="transitionControl.setValue('scroll-left')"
        >
          <mat-icon>west</mat-icon>
        </button>

        <button
          type="button"
          class="icon-button"
          [class.icon-button--active]="transitionControl.value === 'scroll-right'"
          (click)="transitionControl.setValue('scroll-right')"
        >
          <mat-icon>east</mat-icon>
        </button>

        <button
          type="button"
          class="icon-button"
          [class.icon-button--active]="transitionControl.value === 'scroll-top'"
          (click)="transitionControl.setValue('scroll-top')"
        >
          <mat-icon>north</mat-icon>
        </button>

        <button
          type="button"
          class="icon-button"
          [class.icon-button--active]="transitionControl.value === 'scroll-bottom'"
          (click)="transitionControl.setValue('scroll-bottom')"
        >
          <mat-icon>south</mat-icon>
        </button>
      </div>
    </div>

    <div class="form-field-row">
      <mat-form-field>
        <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.COLUMNS' | translate }}</mat-label>
        <input matInput type="number" [formControl]="columnsControl" min="1" max="10" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'PRESENTER.HONOUR_ROLL_TOOLS.ROWS' | translate }}</mat-label>
        <input matInput type="number" [formControl]="rowsControl" min="1" max="50" />
      </mat-form-field>
    </div>

    <div class="opacity-slider-container">
      <h4 class="tools-title">{{ 'PRESENTER.HONOUR_ROLL_TOOLS.SCROLL_SPEED' | translate }}</h4>
      <div class="slider-wrapper">
        <mat-slider min="1" max="60" step="1" discrete>
          <input matSliderThumb [formControl]="scrollSpeedControl" />
        </mat-slider>
        <span class="opacity-value">{{ scrollSpeedControl.value }}</span>
      </div>
    </div>

    <button mat-stroked-button type="button" (click)="openFilterItemsDialog()">
      <span class="button-inner">
        <gb-icon icon="filter" height="18px"></gb-icon>
        <span>{{ 'PRESENTER.ITEM_TABLE_TOOLS.FILTER_ITEMS.BUTTON' | translate }}</span>
      </span>
    </button>

    <div class="opacity-slider-container">
      <h4 class="tools-title">{{ 'PRESENTER.HONOUR_ROLL_TOOLS.OPACITY' | translate }}</h4>

      <div class="slider-wrapper">
        <mat-slider min="0" max="1" step="0.01" discrete>
          <input matSliderThumb [formControl]="opacityControl" />
        </mat-slider>
        <span class="opacity-value">{{ opacityControl.value }}</span>
      </div>
    </div>
  </gb-presenter-tools-advanced-options-container>
</div>
